module.exports = __webpack_public_path__ + "static/img/logo.472b668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 2